import {GoogleDriveFile} from 'types';
import styles from './Attachments.module.scss';
import {separateGoogleDriveFiles} from 'helpers/media';
import {Fragment, useMemo, useState} from 'react';
import Typography from 'components/Typography';
import ImageView from 'components/ImageView';
// import VideoView from 'components/VideoView';
import VideoView from 'components/VideoView';

interface Props {
  attachments: GoogleDriveFile[];
}

function Attachments({attachments}: Props) {
  const [showImages, setShowImages] = useState(false);
  const [showVideos, setShowVideos] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);

  const {images, videos, documents} = useMemo(
    () => separateGoogleDriveFiles(attachments),
    [attachments]
  );

  const handleCloseImages = () => {
    setShowImages(false);
    setSelectedImageIndex(0);
  };
  const handleCloseVideos = () => {
    setShowVideos(false);
    setSelectedVideoIndex(0);
  };
  const handleVideoClick = async (video: GoogleDriveFile, index: number) => {
    setSelectedVideoIndex(index);
    setShowVideos(true);
  };
  const handleImageClick = async (image: GoogleDriveFile, index: number) => {
    setSelectedImageIndex(index);
    setShowImages(true);
  };
  return (
    <div className={styles.container}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Attachments</h2>
      </div>
      {images.length > 0 && (
        <Fragment>
          <Typography component="p" variant="label">
            Images
          </Typography>
          <ImageView
            show={showImages}
            onClose={handleCloseImages}
            images={images.map(
              (image) =>
                `https://drive.google.com/thumbnail?id=${image.file_id}&sz=w2000`
            )}
            selectedImageIndex={selectedImageIndex}
          />
          <div className={styles.attachmentsContainer}>
            {images.map((image, index) => (
              <div key={image.id}>
                <img
                  onClick={() => handleImageClick(image, index)}
                  src={`https://drive.google.com/thumbnail?id=${image.file_id}&sz=w1000`}
                  alt={image.filename}
                  className={styles.attachedImage}
                />
              </div>
            ))}
          </div>
        </Fragment>
      )}
      {videos.length > 0 && (
        <Fragment>
          <Typography component="p" variant="label">
            Videos
          </Typography>

          <VideoView
            show={showVideos}
            onClose={handleCloseVideos}
            videos={videos}
            selectedVideoIndex={selectedVideoIndex}
          />
          <div className={styles.attachmentsContainer}>
            {videos.map((video, index) => (
              <div
                key={video.id}
                onClick={() => handleVideoClick(video, index)}
                className={styles.attachedVideo}
              >
                <div className={styles.videoThumbnail}>
                  <div className={styles.videoPlaceholder}>
                    <svg
                      width="64"
                      height="64"
                      viewBox="0 0 24 24"
                      fill="#666"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
                    </svg>
                  </div>
                  <p className={styles.videoFilename}>{video.filename}</p>
                </div>
                <div className={styles.videoOverlay}>
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="white"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </Fragment>
      )}
      {documents.length > 0 && (
        <Fragment>
          <Typography component="p" variant="label">
            Documents
          </Typography>
          <div className={styles.attachmentsContainer}>
            {documents.map((document) => (
              <div key={document.id}>
                <a
                  href={document.download_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.attachmentLink}
                >
                  {document.filename}
                </a>
              </div>
            ))}
          </div>
        </Fragment>
      )}
    </div>
  );
}
export default Attachments;
